import { Text } from '@/components/@base/typography';
import { TEXT_TYPE } from '@/components/@base/typography/text/type';
import { MARKETS } from '@/components/app/product/components/@shared/type';

import BundleModel from '@/models/bundle.model';
import ProductModel from '@/models/product.model';

export function isBundle(data: BundleModel | ProductModel): data is BundleModel {
  if (data.market === MARKETS.BUNDLE) {
    return true;
  }

  return (data as BundleModel).bundleItems !== undefined;
}

export function formatParagraphNewLine(text: string): React.ReactElement[] {
  return text.split('\n').map((str) => <Text type={TEXT_TYPE.P}>{str}</Text>);
}
